module.exports = __webpack_public_path__ + "img/dark-bg.f63f74c5.jpg";